import React from 'react';
import { motion } from 'framer-motion';
import { Section, Title, ContentBlock, Paragraph } from '../styled/StyledComponents';
import { contentVariants } from '../animations/Variants';
import styled from 'styled-components';

const CenteredTitle = styled(Title)`
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.2rem;
  color: #2c3e50;
`;

const ImageContainer = styled.div`
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 500px;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 3rem;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const TextContent = styled(ContentBlock)`
  flex: 1;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const StyledParagraph = styled(Paragraph)`
  line-height: 1.8;
  color: #4a4a4a;
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
`;

const AccueilSection: React.FC = () => {
  return (
    <motion.div
      key="accueil"
      initial="enter"
      animate="center"
      exit="exit"
      variants={contentVariants}
    >
      <Section>
        <CenteredTitle>Un espace dédié à l'éveil et au développement des tout-petits</CenteredTitle>
        
        <ContentWrapper>
          <TextContent>
            <StyledParagraph>
              Bienvenue sur le site de notre cabinet de psychomotricité spécialisé dans la petite enfance. 
              Ici, nous mettons à cœur d'accompagner chaque enfant dans ses premiers pas vers un développement harmonieux. 
              Grâce à une approche bienveillante et adaptée, nous aidons les tout-petits à explorer leurs capacités motrices, 
              émotionnelles et relationnelles.
            </StyledParagraph>
            <StyledParagraph>
              Découvrez notre expertise et nos services à travers ce site, une porte ouverte vers une prise 
              en charge respectueuse et professionnelle de vos enfants.
            </StyledParagraph>
          </TextContent>
          
          <ImageContainer>
            <StyledImage 
              src="/assets/images/petite_enfance.jpg" 
              alt="Développement de la petite enfance"
            />
          </ImageContainer>
        </ContentWrapper>
      </Section>
    </motion.div>
  );
};

export default AccueilSection;
